export const DELETE_DMX_CONTROLLER = 'DELETE_DMX_CONTROLLER';
export const DELETE_DMX_CONTROLLER_SUCCESSFUL = 'DELETE_DMX_CONTROLLER_SUCCESSFUL';
export const DELETE_DMX_CONTROLLER_FAILED = 'DELETE_DMX_CONTROLLER_FAILED';
